import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-y-4 gap-x-6 px-4" }
const _hoisted_3 = { class: "grid grid-cols-1 gap-x-6 px-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Select = _resolveComponent("Select")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { label: "Aturan Komisi" }),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_DataWrapper, { label: "Acuan Komisi" }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            onOpenSelect: _ctx.onOpenSelectTierBase,
            onCloseSelect: _ctx.onCloseSelectTierBase,
            isOpenMenu: _ctx.isOpenSelectTierBase,
            value: _ctx.form.commissionTierBase,
            onChooseSelect: _ctx.onSelectTierBase,
            dataSelect: _ctx.tierBaseOptions,
            class: "w-full mt-1.5"
          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Harga Acuan Tier" }, {
        default: _withCtx(() => [
          (_ctx.isPriceTierReferenceMandatory)
            ? (_openBlock(), _createBlock(_component_Select, {
                key: 0,
                onOpenSelect: _ctx.onOpenSelectPriceTierReference,
                onCloseSelect: _ctx.onCloseSelectPriceTierReference,
                isOpenMenu: _ctx.isOpenSelectPriceTierReference,
                value: _ctx.form.commissionPriceTierReference,
                onChooseSelect: _ctx.onSelectPriceTierReference,
                dataSelect: _ctx.priceTierReferenceOptions,
                class: "w-full mt-1.5"
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"]))
            : (_openBlock(), _createBlock(_component_LpInput, {
                key: 1,
                disabled: true,
                "model-value": '-'
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Tipe Komisi" }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            onOpenSelect: _ctx.onOpenSelectCommissionType,
            onCloseSelect: _ctx.onCloseSelectCommissionType,
            isOpenMenu: _ctx.isOpenSelectCommissionType,
            value: _ctx.form.commissionType,
            onChooseSelect: _ctx.onSelectCommissionType,
            dataSelect: _ctx.commissionTypeOptions,
            class: "w-full mt-1.5"
          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, { label: "Harga Acuan Komisi" }, {
        default: _withCtx(() => [
          (_ctx.isCommissionQuantifierAndPriceReferenceMandatory)
            ? (_openBlock(), _createBlock(_component_Select, {
                key: 0,
                onOpenSelect: _ctx.onOpenSelectPriceCommissionReference,
                onCloseSelect: _ctx.onCloseSelectPriceCommissionReference,
                isOpenMenu: _ctx.isOpenSelectPriceCommissionReference,
                value: _ctx.form.commissionPriceReference,
                onChooseSelect: _ctx.onSelectPriceCommissionReference,
                dataSelect: _ctx.priceCommissionReferenceOptions,
                class: "w-full mt-1.5"
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"]))
            : (_openBlock(), _createBlock(_component_LpInput, {
                key: 1,
                disabled: true,
                "model-value": '-'
              }))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_DataWrapper, { label: "Parameter Perhitungan" }, {
        default: _withCtx(() => [
          (_ctx.isCommissionQuantifierAndPriceReferenceMandatory)
            ? (_openBlock(), _createBlock(_component_Select, {
                key: 0,
                onOpenSelect: _ctx.onOpenSelectCommissionQuantifier,
                onCloseSelect: _ctx.onCloseSelectCommissionQuantifier,
                isOpenMenu: _ctx.isOpenSelectCommissionQuantifier,
                value: _ctx.form.commissionQuantifier,
                onChooseSelect: _ctx.onSelectCommissionQuantifier,
                dataSelect: _ctx.commissionQuantifierOptions,
                class: "w-full mt-1.5"
              }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"]))
            : (_openBlock(), _createBlock(_component_LpInput, {
                key: 1,
                disabled: true,
                "model-value": '-'
              }))
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ]))
}